export default {
    GET_SINGLE_COURSE: "GET_SINGLE_COURSE",
    GET_MY_SINGLE_COURSE: "GET_MY_SINGLE_COURSE",
    GET_SINGLE_COURSE_ERROR: "GET_SINGLE_COURSE_ERROR",
    GET_SINGLE_COURSE_SUCCESS: "GET_SINGLE_COURSE_SUCCESS",
    CLEAR_SINGLE_COURSE: "CLEAR_SINGLE_COURSE",
};